import { setLocale } from 'yup';

setLocale({
  mixed: {
    default: 'field_invalid',
  },
  
  number: {
    min: ({ min }) => ({ key: 'field_too_short', values: { min } }),
    max: ({ max }) => ({ key: 'field_too_big', values: { max } }),
  },
});
